import { render } from "./ToggleDisplaySettings.vue?vue&type=template&id=b15ae804&scoped=true"
import script from "./ToggleDisplaySettings.vue?vue&type=script&lang=ts"
export * from "./ToggleDisplaySettings.vue?vue&type=script&lang=ts"

import "./ToggleDisplaySettings.vue?vue&type=style&index=0&id=b15ae804&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b15ae804"

export default script